export default {
  title: 'Finden Sie etwas, das Ihnen gefällt!',
  description: 'Ihre Bestellungen werden hier aufgelistet.',
  buttons: {
    order_now: 'Jetzt bestellen',
  },
};
